const MONTHS_ES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export function formatDisplayDate(value) {
  if (!value) {
    return "";
  }

  const [year, month, day] = String(value).split("-");
  const monthIndex = Number(month) - 1;

  if (!year || !month || !day || Number.isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
    return String(value);
  }

  return `${day}-${MONTHS_ES[monthIndex]}-${year}`;
}
